import { useTheme } from '../theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className="flex h-9 w-9 items-center justify-center rounded-full border border-border bg-surface text-text-muted hover:text-text-default focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-blue"
    >
      <i
        aria-hidden="true"
        className={`fa-solid ${isDark ? 'fa-moon' : 'fa-sun'} text-base`}
      />
    </button>
  );
}
